module.exports = __webpack_public_path__ + "static/media/os.28a671e8.png";